export enum SupportTicketResolutionEnum {
  REJECTED = 'REJECTED',
  REJECTED_BY_CUSTOMER = 'REJECTED_BY_CUSTOMER',
  CANNOT_REPRODUCE = 'CANNOT_REPRODUCE',
  FIX_SCHEDULED = 'FIX_SCHEDULED',
  DUPLICATED = 'DUPLICATED',
  LICENSE_UPGRADE_REQUIRED = 'LICENSE_UPGRADE_REQUIRED',
  FEATURE_NOT_EXISTS = 'FEATURE_NOT_EXISTS'
}
